import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../../images/user_avatar.png';
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class TopicIcon extends Component {
  render() {
    return (
        <li className="col">
            <object type="image/svg+xml" data={this.props.icon} class="svg_icon_topic">
                Icon Logo
            </object>
            <div className="topic_name">{this.props.name}</div>
            <div className="topic_desc">{this.props.desc}</div>
        </li>
    );
  }
}

export default TopicIcon;